<mat-progress-bar mode="buffer"></mat-progress-bar>
